import { useEffect, useMemo, useRef, useState } from 'react';
import type { SingleValue } from 'react-select';

import type { MultiChartProps } from '../charts/types';

export const useMultiChartProps = (multiChartProps: MultiChartProps) => {
  const isMulti = Array.isArray(multiChartProps);
  const [chartProps, setChartProps] = useState(isMulti ? multiChartProps[0]! : multiChartProps);

  // This block is NEEDED to workaround the issue with the chart props not being
  // updated when switching instances in metrics view.
  // What it actually does is to force the chart props to be updated the second time
  // the hook is called.
  // TODO: find a better solution.
  const updateWorkaround = true;
  const azRef = useRef(updateWorkaround);

  useEffect(() => {
    if (azRef.current === updateWorkaround) {
      setChartProps(isMulti ? multiChartProps[0]! : multiChartProps);
    }
  }, [isMulti, multiChartProps, updateWorkaround]);

  const chartDropdownOptions = useMemo(() => {
    if (!isMulti) {
      return null;
    }

    const options = multiChartProps.map((p) => ({
      label: p.subtitle,
      value: p,
    }));

    return {
      options,
      onChange: (newValue: SingleValue<(typeof options)[number]>) => {
        if (newValue?.value) {
          setChartProps(newValue.value);
        }
      },
      value: {
        label: chartProps.subtitle,
        value: chartProps,
      },
    };
  }, [chartProps, isMulti, multiChartProps]);

  return { chartProps, chartDropdownOptions };
};
